export default function translate(dictionary: Record<string, string> = {}) {
	const t = (text: string, params: (string | number)[] = []) => {
		let result = dictionary[text] || text;
		params.forEach((p, i) => {
			result = result.replace('{' + i + '}', typeof p === 'number' ? p.toString() : p);
		});
		return result;
	};
	return t;
}
